import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'

Vue.config.productionTip = false
Vue.use(VueRouter)
const router=new VueRouter({
  routes:App.routes
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
